
     $(function () {
       $('.multi-collapse1').addClass('hide');
       $('.multi-collapse2').addClass('hide');
       $('.multi-collapse3').addClass('hide');
       
    $('.benefit-1-color a').on('click',function () {
      
        $('.multi-collapse1').toggleClass('hide');
        $('.benefit-1-color a').toggleClass('collapsed');
        $('.benefit-2-color a').toggleClass('collapsed');
      
    });
       $('.benefit-2-color a').on('click',function () {
      
        $('.multi-collapse1').toggleClass('hide');
        $('.benefit-1-color a').toggleClass('collapsed');
        $('.benefit-2-color a').toggleClass('collapsed');
      
    });
       $('.benefit-3-color a').on('click',function () {
        $('.multi-collapse2').toggleClass('hide');
        $('.benefit-3-color a').toggleClass('collapsed');
        $('.benefit-4-color a').toggleClass('collapsed');
         
    });
       $('.benefit-4-color a').on('click',function () {
        $('.multi-collapse2').toggleClass('hide');
        $('.benefit-3-color a').toggleClass('collapsed');
        $('.benefit-4-color a').toggleClass('collapsed');
         
    });
        $('.benefit-5-color a').on('click',function () {
        $('.multi-collapse3').toggleClass('hide');
        $('.benefit-5-color a').toggleClass('collapsed');
        $('.benefit-6-color a').toggleClass('collapsed');
          
    });
        $('.benefit-6-color a').on('click',function () {
        $('.multi-collapse3').toggleClass('hide');
        $('.benefit-5-color a').toggleClass('collapsed');
        $('.benefit-6-color a').toggleClass('collapsed');
          
    });
       $(".control a").prop("href", "javascript:void(0)");
});

$('.slick-t').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: true,
   focusOnSelect: true
 });